export const buildAddressLines = (address) => {
  if (!address) return [];
  const streetLine = [address.street, address.apt ? `Apt ${address.apt}` : ""].filter(Boolean).join(", ");
  const cityLine = `${address.city ? `${address.city},` : ""} ${address.state ?? ""} ${address.zip ?? ""}`.trim();
  return [streetLine, cityLine].filter(Boolean);
};

// Maps the page's mailing-address shape to the check request API payload.
export const toCheckRequestAddress = (address) => ({
  address_line1: [address?.street, address?.apt ? `Apt ${address.apt}` : ""].filter(Boolean).join(", "),
  city: address?.city ?? "",
  state: address?.state ?? "",
  zip: address?.zip ?? "",
  country: "US",
});

// Normalizes the check request API address back into the page's address shape
// so the success screen can render whichever address the server confirmed.
export const fromCheckResponseAddress = (apiAddress, fallbackAddress) => {
  if (!apiAddress) return fallbackAddress;
  return {
    firstName: fallbackAddress?.firstName ?? "",
    lastName: fallbackAddress?.lastName ?? "",
    street: apiAddress.address_line1 ?? fallbackAddress?.street ?? "",
    apt: "",
    city: apiAddress.city ?? fallbackAddress?.city ?? "",
    state: apiAddress.state ?? fallbackAddress?.state ?? "",
    zip: apiAddress.zip ?? fallbackAddress?.zip ?? "",
  };
};
